import Cookies from "js-cookie";
import pick from "ramda/src/pick";
import mapObjIndexed from "ramda/src/mapObjIndexed";

// WARNING: jQuery.Cookie é incompatível com js-cookie
// https://github.com/carhartl/jquery-cookie (utilizada no portal)
// https://github.com/js-cookie/js-cookie (utilizada no b2b)
// Funções unwrap/wrap para compatibilidade
const unwrap = (mixed) => decodeURIComponent(mixed).replace(/^"(.*)"$/, "$1");
const wrap = (raw) => JSON.stringify(raw);

export function getCookie(key) {
  const value = Cookies.get(key);
  return (
    value && (key ? unwrap(value) : mapObjIndexed((v, k) => unwrap(v), value))
  );
}

export function filterCookies(keys) {
  return pick(keys, getCookie());
}

export function setCookie(key, value, options) {
  Cookies.set(key, wrap(value), options || { expires: 1, path: "/" });
}

export function removeCookie(key) {
  Cookies.remove(key, { path: "/" });
}

export function removeCookies(keys) {
  keys.forEach(removeCookie);
}

export function getCookieAsJSON(key) {
  const value = getCookie(key);
  return value && JSON.parse(value);
}



// WEBPACK FOOTER //
// ./src/services/utils/cookie.js